import BSCoreApiClient from '@anbsystems/business-services-core-api-client'
import Constants from '../constants'
import AuthSvc from './auth'

class HelpDocumentsService {
  static getBsCoreApiClient(baseApiUrl) {
    return new BSCoreApiClient({ baseURL: baseApiUrl.public.BUSINESS_SERVICE_CORE_API_URL })
  }

  static find(query, fields, baseApiUrl) {
    const bsCoreApiClient = this.getBsCoreApiClient(baseApiUrl)
    return bsCoreApiClient.helpContents.find(
      AuthSvc.getOptions(),
      query,
      fields,
      Constants.CURRENT_PAGE,
      Constants.MAX_PER_PAGE,
      { createdAt: -1 }
    )
  }

  static signedUrl(id, baseApiUrl) {
    const bsCoreApiClient = this.getBsCoreApiClient(baseApiUrl)
    return bsCoreApiClient.helpContents.signedUrl(AuthSvc.getOptions(), id)
  }
}

export default HelpDocumentsService
